var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.832,
    height: 14.665,
    viewBox: "0 0 12.832 14.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "building") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#758091;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.488,13.748h-.573V.687A.687.687,0,0,0,11.228,0H1.6A.687.687,0,0,0,.917.687V13.748H.344A.344.344,0,0,0,0,14.092v.573H12.832v-.573A.344.344,0,0,0,12.488,13.748ZM3.666,2.177a.344.344,0,0,1,.344-.344H5.156a.344.344,0,0,1,.344.344V3.322a.344.344,0,0,1-.344.344H4.01a.344.344,0,0,1-.344-.344Zm0,2.75a.344.344,0,0,1,.344-.344H5.156a.344.344,0,0,1,.344.344V6.072a.344.344,0,0,1-.344.344H4.01a.344.344,0,0,1-.344-.344ZM5.156,9.165H4.01a.344.344,0,0,1-.344-.344V7.676a.344.344,0,0,1,.344-.344H5.156a.344.344,0,0,1,.344.344V8.822A.344.344,0,0,1,5.156,9.165Zm2.177,4.583H5.5V11.342A.344.344,0,0,1,5.843,11H6.989a.344.344,0,0,1,.344.344ZM9.165,8.822a.344.344,0,0,1-.344.344H7.676a.344.344,0,0,1-.344-.344V7.676a.344.344,0,0,1,.344-.344H8.822a.344.344,0,0,1,.344.344Zm0-2.75a.344.344,0,0,1-.344.344H7.676a.344.344,0,0,1-.344-.344V4.926a.344.344,0,0,1,.344-.344H8.822a.344.344,0,0,1,.344.344Zm0-2.75a.344.344,0,0,1-.344.344H7.676a.344.344,0,0,1-.344-.344V2.177a.344.344,0,0,1,.344-.344H8.822a.344.344,0,0,1,.344.344Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.2c8754752eaabd1bbed85169a17cfd69.svg";
export { ForwardRef as ReactComponent };